import React from 'react';
export default (props => /*#__PURE__*/React.createElement("ellipse", props));
//# sourceMappingURL=index.js.map